/**
 * Рассылки, за которыми следит открытая вкладка: когда отправка закончится, бэкофис
 * покажет итог, даже если сотрудник ушёл на другую страницу. Список живёт в
 * sessionStorage, поэтому переживает перезагрузку, но не попадает в другие вкладки.
 */
export interface WatchedBroadcast {
	botId: string
	id: string
	name: string
}

const STORAGE_KEY = "backoffice:watched-broadcasts"
export const WATCHED_BROADCASTS_CHANGED = "backoffice:watched-broadcasts"

export function readWatchedBroadcasts(): WatchedBroadcast[] {
	try {
		const value: unknown = JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? "[]")
		return Array.isArray(value) ? (value as WatchedBroadcast[]) : []
	} catch {
		return []
	}
}

function write(list: WatchedBroadcast[]) {
	try {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list))
	} catch {
		// Без хранилища следим только до перезагрузки: событие ниже всё равно уйдёт.
	}
	window.dispatchEvent(new CustomEvent(WATCHED_BROADCASTS_CHANGED, { detail: list }))
}

export function watchBroadcast(broadcast: WatchedBroadcast) {
	const list = readWatchedBroadcasts()
	if (list.some((item) => item.id === broadcast.id)) return
	write([...list, broadcast])
}

export function unwatchBroadcast(id: string) {
	write(readWatchedBroadcasts().filter((item) => item.id !== id))
}
